// extracted by mini-css-extract-plugin
export var actions = "_c-0";
export var actionsContainer = "_c-7";
export var border = "_c-1";
export var childFullHeight = "_c-g";
export var collapse = "_c-2";
export var content = "_c-b";
export var contentChild = "_c-f";
export var fullscreen = "_c-d";
export var hasLeftRadius = "_c-l";
export var headerContainer = "_c-3";
export var headerRow = "_c-5";
export var hidePadding = "_c-c";
export var navCollapsedGap = "_c-m";
export var noScrollX = "_c-n";
export var noScrollY = "_c-o";
export var noTopPadding = "_c-j";
export var optOutTopPadding = "_c-e";
export var pageMain = "_c-k";
export var pageOuter = "_c-h";
export var pagePadding = "_c-8";
export var pageScroll = "_c-9";
export var profile = "_c-p";
export var profileContainer = "_c-q";
export var profileImage = "_c-r";
export var profileMain = "_c-s";
export var profileSubtitle = "_c-u";
export var profileTitle = "_c-t";
export var settingsSurface = "_c-a";
export var showLeftPadding = "_c-i";
export var tabsPortalSlot = "_c-6";
export var tabsWrapper = "_c-4";
export var title = "_c-v";